export default [
    {
        path: '/emailClients',
        name: 'emailClients',
        component: () => import( /* webpackChunkName: "emailClients" */ '@/views/directory/EmailClients.vue')
    },
    {
        path: '/emailSignature/:id',
        name: 'emailSignature',
        component: () => import( /* webpackChunkName: "emailSignature" */ '@/views/directory/EmailSignature.vue')
    },
    {
        path: '/employeeAdd/:id',
        name: 'employeeAdd',
        component: () => import( /* webpackChunkName: "employeeAdd" */ '@/views/directory/EmployeeAdd.vue')
    },
    {
        path: '/entity/:id',
        name: 'entity',
        component: () => import( /* webpackChunkName: "entity" */ '@/views/directory/Entity.vue')
    },
    {
        path: '/entityTypes',
        name: 'entityTypes',
        component: () => import( /* webpackChunkName: "entityTypes" */ '@/views/directory/Types.vue')
    },
    {
        path: '/entityTypes/add',
        name: 'entityTypeAdd',
        component: () => import( /* webpackChunkName: "entityType" */ '@/views/directory/Type.vue')
    },
    {
        path: '/entityTypes/:id',
        name: 'entityType',
        component: () => import( /* webpackChunkName: "entityType" */ '@/views/directory/Type.vue')
    },
    {
        path: '/entityTypes/:id/entities/create',
        name: 'entityCreate',
        component: () => import( /* webpackChunkName: "entityCreate" */ '@/views/directory/EntityCreate.vue')
    },
    {
        path: '/entrySearch/:objectType/:objectId/:typeId/:relatedId?',
        name: 'entrySearch',
        component: () => import( /* webpackChunkName: "entrySearch" */ '@/views/directory/EntrySearch.vue')
    },
    {
        path: '/entryType/:objectType/:objectId/:relatedId?',
        name: 'entryType',
        component: () => import( /* webpackChunkName: "entryType" */ '@/views/directory/EntryType.vue')
    },
    {
        path: '/groups/:id?',
        name: 'groups',
        component: () => import( /* webpackChunkName: "groups" */ '@/views/directory/Groups.vue')
    },
    {
        path: '/groups/assign/:id?',
        name: 'groupAssign',
        component: () => import( /* webpackChunkName: "groupAssign" */ '@/views/directory/GroupAssign.vue')
    },
    {
        path: '/groups/create/:id',
        name: 'groupCreate',
        component: () => import( /* webpackChunkName: "groupCreate" */ '@/views/directory/GroupCreate.vue')
    },
    {
        path: '/groups/edit/:id',
        name: 'group',
        component: () => import( /* webpackChunkName: "group" */ '@/views/directory/Group.vue')
    },
    {
        path: '/holidays/list',
        name: 'holidayList',
        component: () => import( /* webpackChunkName: "holidayList" */ '@/views/directory/HolidayList.vue')
    },
    {
        path: '/holidays/add',
        name: 'holidayAdd',
        component: () => import( /* webpackChunkName: "holidayAdd" */ '@/views/directory/HolidayAdd.vue')
    },
    {
        path: '/holidays/calendar',
        name: 'holidayCalendar',
        component: () => import( /* webpackChunkName: "holidayCalendar" */ '@/views/directory/HolidayCalendar.vue')
    },
    {
        path: '/holidays/conflicts',
        name: 'holidayConflicts',
        component: () => import( /* webpackChunkName: "holidayConflicts" */ '@/views/directory/HolidayConflicts.vue')
    },
    {
        path: '/holidays/entities/:id',
        name: 'holidayEntity',
        component: () => import( /* webpackChunkName: "holidayEntity" */ '@/views/directory/HolidayEntity.vue')
    },
    {
        path: '/holidays/entities',
        name: 'holidayEntityPublicHoliday',
        component: () => import( /* webpackChunkName: "holidayEntity" */ '@/views/directory/HolidayEntity.vue')
    },
    {
        path: '/keycloak',
        name: 'keycloak',
        component: () => import( /* webpackChunkName: "keycloak" */ '@/views/directory/Keycloak.vue')
    },
    {
        path: '/logAccess',
        name: 'logAccess',
        component: () => import( /* webpackChunkName: "logAccess" */ '@/views/directory/LogAccess.vue')
    },
    {
        path: '/merge/:id/:mergeid',
        name: 'merge',
        component: () => import( /* webpackChunkName: "merge" */ '@/views/directory/Merge.vue')
    },
    {
        path: '/panelNumbers',
        name: 'panelNumbers',
        component: () => import( /* webpackChunkName: "panelNumbers" */ '@/views/directory/PanelNumbers.vue')
    },
    {
        path: '/planner',
        name: 'planner',
        component: () => import( /* webpackChunkName: "planner" */ '@/views/directory/Planner.vue')
    },
    {
        path: '/reviews',
        name: 'reviews',
        component: () => import( /* webpackChunkName: "reviews" */ '@/views/directory/Reviews.vue')
    },
    {
        path: '/reviewSites',
        name: 'reviewSites',
        component: () => import( /* webpackChunkName: "reviewSites" */ '@/views/directory/ReviewSites.vue')
    },
    {
        path: '/reviewSites/add',
        name: 'reviewSiteAdd',
        component: () => import( /* webpackChunkName: "reviewSite" */ '@/views/directory/ReviewSite.vue')
    },
    {
        path: '/reviewSites/:id',
        name: 'reviewSite',
        component: () => import( /* webpackChunkName: "reviewSite" */ '@/views/directory/ReviewSite.vue')
    },
    {
        path: '/roles',
        name: 'roles',
        component: () => import( /* webpackChunkName: "roles" */ '@/views/directory/Roles.vue')
    },
    {
        path: '/roles/add',
        name: 'roleAdd',
        component: () => import( /* webpackChunkName: "role" */ '@/views/directory/Role.vue')
    },
    {
        path: '/roles/:id',
        name: 'role',
        component: () => import( /* webpackChunkName: "role" */ '@/views/directory/Role.vue')
    },
    {
        path: '/satisfaction/:id',
        name: 'satisfaction',
        component: () => import( /* webpackChunkName: "satisfaction" */ '@/views/directory/Satisfaction.vue')
    },
    {
        path: '/tasks',
        name: 'tasks',
        component: () => import( /* webpackChunkName: "tasks" */ '@/views/directory/Tasks.vue')
    },
    {
        path: '/tasks/add',
        name: 'taskAdd',
        component: () => import( /* webpackChunkName: "task" */ '@/views/directory/Task.vue')
    },
    {
        path: '/tasks/edit/:id',
        name: 'task',
        component: () => import( /* webpackChunkName: "task" */ '@/views/directory/Task.vue')
    },
    {
        path: '/teams',
        name: 'teams',
        component: () => import( /* webpackChunkName: "teams" */ '@/views/directory/Teams.vue')
    },
    {
        path: '/teams/add',
        name: 'teamAdd',
        component: () => import( /* webpackChunkName: "team" */ '@/views/directory/Team.vue')
    },
    {
        path: '/teams/edit/:id',
        name: 'team',
        component: () => import( /* webpackChunkName: "team" */ '@/views/directory/Team.vue')
    },
    {
        path: '/teams/assign/main/:objectType/:objectId/:relatedId?',
        name: 'teamAssign',
        component: () => import( /* webpackChunkName: "teamAssign" */ '@/views/directory/TeamAssign.vue')
    },
    {
        path: '/teams/assign/future/:objectType/:objectId/:relatedId?',
        name: 'teamFutureAssign',
        component: () => import( /* webpackChunkName: "teamFutureAssign" */ '@/views/directory/TeamFutureAssign.vue')
    },
    {
        path: '/users',
        name: 'users',
        component: () => import( /* webpackChunkName: "users" */ '@/views/directory/Users.vue')
    },
]